import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const CREATE_SHARED_MEDIA = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createSharedMedia',
    operationName: 'createSharedMedia',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'file_content', type: 'String', required: true },
      { name: 'file_type', type: 'String' },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'file_content', value: 'file_content' },
      { name: 'file_type', value: 'file_type' },
    ],
    fields: '{...SharedMediaResponseFields}',
    fragments: [Fragments.sharedMediaResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const DELETE_SHARED_MEDIA = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'deleteSharedMedia',
    operationName: 'deleteSharedMedia',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
    ],
    fields: '{ success message }',
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
